import type { ClaimProps } from "@/scott/ui/blocks/claim/claim";
import { getBlockId } from "@/services/contentful/assemblies/page/adapter/utils";
import {
  UiConfigurationAdapter,
  type UiConfigurationInput,
} from "@/services/contentful/topics/UIConfiguration/ui-configuration.adapter";
import type {
  RawContentBlockBase,
  SectionClaimPageBlock,
} from "@/types/page-block";

export type SectionClaimInput = RawContentBlockBase &
  Omit<ClaimProps, "backgroundColor"> & {
    __typename: "SectionClaim";
    claimText: string;
    uiConfiguration?: UiConfigurationInput;
  };

export function SectionClaimAdapter(
  item: SectionClaimInput,
  index: number
): SectionClaimPageBlock {
  const uiConfig = item.uiConfiguration
    ? UiConfigurationAdapter(item.uiConfiguration)
    : undefined;

  return {
    sys: item.sys,
    id: getBlockId(item, index),
    __typename: item.__typename,
    internalName: item.internalName,
    text: item.claimText,
    fullWidth: item.fullWidth,
    offsetLeft: item.offsetLeft,
    backgroundColor: uiConfig?.backgroundColor,
    paddingTop: uiConfig?.paddingTop,
    paddingBottom: uiConfig?.paddingBottom,
  };
}
